export default function () {
  return {
    produtos: [
      {
        nome_produto: "Flex Familia",
        nome_plano: "Flex Familia",
        id_plano: 5,
        id_produto: 2,
        link: "Flex-Familia",
        valor: 49.9,
        descricao: `Valor único para até 4 (quatro) familiares. \n
                    Fidelização de 12 (doze) meses. \n
                    Descontos de até 50% em serviços médicos e demais parceiros.`,
      },
      {
        nome_produto: "Flex Multi",
        nome_plano: "Flex Multi",
        id_plano: 8,
        id_produto: 4,
        link: "Flex-Multi",
        valor: 134.9,
        descricao: `Invividual.\n
                    Fidelização de 6 (seis) meses. \n
                    Descontos de até 80% em serviços médicos e demais parceiros.`,
      },
      {
        nome_produto: "Flex Familia Rio",
        nome_plano: "Flex Familia Rio",
        id_plano: 7,
        id_produto: 2,
        link: "Flex-Familia-Rio",
        valor: 19.9,
        descricao: `Será substituido pelo Flex Essencial em breve \n
                    Valor único para até 4 (quatro) familiares. \n
                    Fidelização de 12 (doze) meses. \n
                    Descontos de até 50% em serviços médicos e demais parceiros.`,
      },
      {
        nome_produto: "Flex Familia Top",
        nome_plano: "Flex Familia Top",
        id_plano: 12,
        id_produto: 7,
        link: "Flex-Familia-top",
        valor: 0,
        descricao: `Valor único para até 4 (quatro) familiares. \n
                    Fidelização de 12 (doze) meses. \n
                    Descontos de até 50% em serviços médicos e demais parceiros.`,
      },
      {
        nome_produto: "Flex Multi Top",
        nome_plano: "Flex Multi Top",
        id_plano: 9,
        id_produto: 5,
        link: "Flex-Multi-Top",
        valor: 0,
        descricao: `Individual.\n
                    Sem fidelização \n
                    Descontos de até 80% em serviços médicos e parceiros Exclusivos.`,
      },
    ],
  };
}
